var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg011OfficeBuildingCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M38.438 12.292h-10.73V1.562C27.708.7 27.01 0 26.146 0H1.562C.7 0 0 .7 0 1.563v36.874C0 39.301.7 40 1.563 40h36.874c.864 0 1.563-.7 1.563-1.563V13.855c0-.863-.7-1.562-1.563-1.562zM3.124 3.125h21.458v33.75H3.125V3.125zm33.75 33.75h-9.167V15.417h9.167v21.458zM12.344 7.708c0 .863-.7 1.563-1.563 1.563H7.708a1.562 1.562 0 1 1 0-3.125h3.073c.863 0 1.563.7 1.563 1.562zm0 9.22c0 .862-.7 1.562-1.563 1.562H7.708a1.562 1.562 0 1 1 0-3.125h3.073c.863 0 1.563.7 1.563 1.562zm0 9.218c0 .863-.7 1.562-1.563 1.562H7.708a1.562 1.562 0 1 1 0-3.125h3.073c.863 0 1.563.7 1.563 1.563zm9.219-18.438c0 .863-.7 1.563-1.563 1.563h-3.073a1.562 1.562 0 1 1 0-3.125H20c.863 0 1.563.7 1.563 1.562zm0 9.22c0 .862-.7 1.562-1.563 1.562h-3.073a1.562 1.562 0 1 1 0-3.125H20c.863 0 1.563.7 1.563 1.562zm0 9.218c0 .863-.7 1.562-1.563 1.562h-3.073a1.562 1.562 0 1 1 0-3.125H20c.863 0 1.563.7 1.563 1.563zM29.192 20c0-.863.7-1.563 1.562-1.563h3.073a1.562 1.562 0 1 1 0 3.125h-3.073c-.863 0-1.562-.699-1.562-1.562zm0 6.146c0-.863.7-1.563 1.562-1.563h3.073a1.562 1.562 0 1 1 0 3.125h-3.073c-.863 0-1.562-.7-1.562-1.562z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg011OfficeBuildingCopy);
export default __webpack_public_path__ + "static/media/011-office-building-copy.c0ab846bb8cfb4ee4da850de09416d8e.svg";
export { ForwardRef as ReactComponent };